<template>
    <Badge
        text="Premium"
        :color="tailwind.theme.color.brand.gold"
        class="mx-5 h-6 w-fit cursor-default"
        light
        roundSize="md"
    />
</template>

<script setup>
import tailwind from '@/lib/tailwind'
import Badge from '@/components/Badge.vue'
</script>
